import React from "react";
import { motion } from "framer-motion";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

export default function Contact({ contact = {} }) {
  const rows = [
    { icon: MapPin, label: "Endereço", value: contact.address, testid: "contact-address" },
    { icon: Phone, label: "Telefone", value: contact.phone, testid: "contact-phone" },
    { icon: Mail, label: "E-mail", value: contact.email, testid: "contact-email" },
    { icon: Clock, label: "Horários", value: contact.hours, testid: "contact-hours" },
  ];
  return (
    <section
      id="contato"
      data-testid="contact-section"
      className="relative bg-stone-950 py-14 md:py-20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-14">
        <div>
          <span className="text-xs tracking-[0.3em] uppercase text-amber-500 font-semibold">
            {contact.label || "Fale Conosco"}
          </span>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-stone-50 mt-4 max-w-md">
            {contact.title || "Venha nos Visitar"}
          </h2>
        </div>

        <div className="flex flex-col gap-2">
          {rows.map((r, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08, duration: 0.6 }}
              data-testid={r.testid}
              className="flex items-start gap-5 border-b border-stone-800 py-6"
            >
              <r.icon className="h-5 w-5 text-amber-500 mt-1 shrink-0" />
              <div>
                <p className="text-xs tracking-[0.2em] uppercase text-stone-500 font-semibold">
                  {r.label}
                </p>
                <p className="text-stone-100 text-lg mt-1">{r.value}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
